import React from "react";

import {
  Input,
  Col,
  Space,
  Button,
  message,
  Row,
  Tooltip,
  Modal,
  Image,
  Drawer,
} from "antd";
import { Link } from "react-router-dom";

import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";

import { CloseOutlined } from "@ant-design/icons";
import VehicleReturnAssetsStore from "../store/VehicleReturnAssetsStore";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import VehicleReturnAssetsAdd from "./VehicleReturnAssetsAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";

import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

class VehicleReturnAssetList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.returnAssetStore = new VehicleReturnAssetsStore();
    this.companyStore = new CompanyStore(this);
    this.state = {
      offset: "",
      limit: "",
      status: "",
      loading: false,
      pageSize: 50,
      currentPage: 1,
      distributor: "",
      distributorType: "",

      company_name: "",
      emailId: "",
      companyId: "",
      companyVal_Lab: "",
      openReturnAssetForm: false,
      returnAssetId: "",
      listDataUpdate: false,
      companyFieldHighlight: false,
      searchField: "",

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: "Driver Name",
        title: context.translate("_DRIVER_NAME_"),
        dataIndex: "drivername",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("vehiclereturnassetlist") &&
                  this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ALLOCATE_DATE_"),
        dataIndex: "allocateDate",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_RETURNED_DATE_"),
        dataIndex: "returnDate",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },

      {
        title: context.translate("_DAYS_USED_"),
        dataIndex: "totalUsedDays",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_RETURNED_FROM_"),
        dataIndex: "allocateTo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          // console.log("value",value)
          if (value === "1") {
            return <>Driver</>;
          } else if (value === "2") {
            return <>Project</>;
          }
        },
      },
      {
        title: context.translate("_TOTAL_AMOUNT_"),
        dataIndex: "totalAmountCharge",
        width: 12,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "returnStatus",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          // console.log(typeof(value))
          if (value === "1") {
            return <>Vehicle Returned</>;
          }
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        width: 7,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {/* <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.onEdit(record);
                  }}
                >
                  <Tooltip
                    // title="Edit Return Asset"
                    title={this.context.translate("_EDIT_RETURN_ASSET_")}
                    placement="bottom"
                    color={config.tooltipColorEdit}
                  >
                    <EditFilled />
                  </Tooltip>
                </Link> */}
                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete Asset"
                      title={this.context.translate(
                        "_FLEET_VEHICLE_VEHICLELIST_DELETE_"
                      )}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}

                {this.props.canUpdate("vehiclereturnassetlist") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}

                {this.props.canDelete("vehiclereturnassetlist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];

    this.ExportMenuProps = {
      items: [
        {
          // label: "Excel",
          label: context.translate("_EXPORT_AS_EXCEL_"),
          key: "excel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },
      ],
      onClick: (val) => {
        if (this.returnAssetStore?.returnAsset?.length == 0) return;
        const result = [];
        this.columns.map((obj) => result.push(obj.dataIndex));

        var getData = {
          cid: this.state.companyId,
          searchField: this.state.searchField,
          colList: result,
        };

        if (val.key == "excel") {
          this.returnAssetStore.exportExcel(getData);
        }
      },
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setReturnAssetStates =
        this.context.viewStateStore.returnAssetObject;

      if (setReturnAssetStates.companyId !== "") {
        await this.setState({ companyId: setReturnAssetStates.companyId });
        await this.returnAssetStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          searchField: setReturnAssetStates.searchField,
          companyId: setReturnAssetStates.companyId,
        });
        const singleData = await this.companyStore.getCompanyDataById(
          setReturnAssetStates.companyId
        );

        await this.setState({ loadList: 1 });

        await this.setState({ companyVal_Lab: singleData });
      }
      this.setState({ listDataUpdate: false });
    }
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    // await this.returnAssetStore.loadData({ offset: 0, limit: 50 });
    this.setState({ pageSize: 50 });
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      pageSize: 50,
      currentPage: 1,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.returnAssetStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });

    await this.setState({ loadData: 1 });
  }

  async searchInputButton() {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.returnAssetStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        companyId: this.state.companyId,
      });
      await this.setState({ loadData: 1 });
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  onEdit = (record) => {
    const vehicleId = record.Id;
    if (vehicleId) {
      this.context.viewStateStore.setReturnAssetStates({
        companyId: record.companyId,
      });
      this.setState({ openReturnAssetForm: true });
      this.setState({ returnAssetId: vehicleId });
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.returnAssetStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        searchField: "",
      });
    }
    this.setState({ loading: false, searchField: "", currentPage: 1 });
  };
  async onDelete(record) {
    const response = await this.returnAssetStore.deleteRecord({
      Id: record.Id,
    });

    if (response?.data?.success === "S") {
      message.success("Returned Vehicle Removed");
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  searchInput = async (e) => {
    const value = e.target.value;
    // await this.setState({searchField:value})
    if (value.length >= 3 || value.length === 0) {
      await this.returnAssetStore.loadData({
        offset: 0,
        limit: this.state.pageSize,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1 });
    }
  };
  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      // this.props.navigate("/vehiclereturnassetlist");
      this.setState({ openReturnAssetForm: false });
      this.setState({ listDataUpdate: true });
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(value["username"]);
      });
    }
  };

  closeModal = () => {
    this.setState({ openReturnAssetForm: false, returnAssetId: "" });
  };
  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  onChange={(value) => this.handleChange(value)}
                  style={companyInputBox}
                />

                <Input
                  placeholder={this.context.translate(
                    "_SEARCH_BY_VEHICLE_NO_DRIVER_NAME_"
                  )}
                  style={{ width: 400, borderRadius: "25px" }}
                  value={this.state.searchField ? this.state.searchField : ""}
                  onChange={(e) => {
                    this.setState({ searchField: e.target.value });
                    this.searchInput(e);
                  }}
                />
                {/* <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.searchInputButton();
                  }}
                /> */}
              </Space>
            </Col>

            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.returnAssetStore?.returnAsset?.length > 0
                      ? false
                      : true
                  }
                  onClick={(val) => {
                    let result = [];
                    if (true) {
                      const result = [];
                      this.columns.map((obj) => result.push(obj.dataIndex));

                      var getData = {
                        cid: this.state.companyId,
                        searchField: this.state.searchField,
                        colList: result,
                      };
                      if (val) {
                        this.returnAssetStore.exportExcel(getData);
                      }
                    }
                  }}
                >
                  <Tooltip
                    title={this.context.translate("_EXPORT_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: 18,
                        width: "auto",
                      }}
                      src={downloadIcon}
                    />
                  </Tooltip>
                </Button>

                {this.props.canCreate("vehiclereturnassetlist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() =>
                      this.setState({
                        returnAssetId: "",
                        openReturnAssetForm: true,
                      })
                    }
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.returnAssetStore?.total}
            columns={this.columns}
            dataSource={this.returnAssetStore?.returnAsset}
            loading={this.returnAssetStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openReturnAssetForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openReturnAssetForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_RETURN_ASSET_")}
                <p className="formDescription">
                  {this.context.translate("_RETURN_VEHICLE_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openReturnAssetForm: false })}
            onCancel={() =>
              this.setState({ openReturnAssetForm: false, userId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <VehicleReturnAssetsAdd
                returnAssetId={this.state.returnAssetId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}

VehicleReturnAssetList.contextType = StoreContext;
export default observer(withRouter(VehicleReturnAssetList));
